import React from "react";
import CustomLink from "../CustomLink/CustomLink";
import "./Header.css";

const Header = () => {
  return (
    <div className="header">
      <nav className="nav-menu">
        <CustomLink to="/home">HOME</CustomLink>
        <CustomLink to="/review">REVIEW</CustomLink>
        <CustomLink to="/dashboard">DASHBOARD</CustomLink>
        <CustomLink to="/blogs">BLOGS</CustomLink>
        <CustomLink to="/about">ABOUT</CustomLink>
      </nav>
    </div>
  );
};

export default Header;
